'use client';
import React, { Children, useEffect } from 'react';
import { Provider } from 'react-redux';
import store, { mapRedux } from '@/redux/index';

export default function StoreProvider({ children }) {
    return (
        <Provider store={store}>
            {Children.map(children, (child) => {
                return child;
            })}
        </Provider>
    );
}

// 获取 获取服务端 state 更新到全局中
export const ReduxInitialStates = mapRedux()((props) => {
    const {
        dispatch: {
            setAll: { initialState },
            common: { resetState },
        },
    } = props;
    useEffect(() => {
        initialState();
    }, []);

    return null;
});
